import { useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowLeft, MapPin } from "lucide-react";
import { PublicLayout } from "@/components/PublicLayout";
import { Markdown } from "@/components/Markdown";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";

export default function BlogPost() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { data: post, isLoading, isError } = useQuery({
    queryKey: ["blog", slug],
    queryFn: async () => (await api.get(`/blog/${slug}`)).data,
  });

  useEffect(() => {
    if (post) document.title = `${post.title} | Climateasy`;
  }, [post]);

  return (
    <PublicLayout>
      <article className="mx-auto max-w-3xl px-4 py-14 sm:px-6 lg:px-8">
        <Link to="/blog" className="inline-flex items-center gap-1 text-sm font-medium text-slate-500 hover:text-[#263871]"><ArrowLeft className="h-4 w-4" />Retour au blog</Link>
        {isLoading ? (
          <p className="mt-8 text-slate-500">Chargement…</p>
        ) : isError || !post ? (
          <p className="mt-8 text-slate-500">Article introuvable.</p>
        ) : (
          <>
            <span className="mt-6 flex items-center gap-1.5 text-sm font-semibold text-[#1D9BF0]"><MapPin className="h-4 w-4" />{post.city} · {post.service}</span>
            <h1 className="mt-3 text-3xl font-extrabold leading-tight text-[#263871] sm:text-4xl">{post.title}</h1>
            <div className="mt-8">
              <Markdown text={post.body_md} />
            </div>
            <div className="cl-gradient mt-12 flex flex-col items-center gap-4 rounded-2xl p-8 text-center text-white">
              <h3 className="text-xl font-bold">Besoin d'un technicien à {post.city} ?</h3>
              <Button onClick={() => navigate("/inscription")} className="rounded-full bg-white text-[#263871] hover:bg-sky-50">Réserver maintenant</Button>
            </div>
          </>
        )}
      </article>
    </PublicLayout>
  );
}
